import { render, staticRenderFns } from "./Tariff.vue?vue&type=template&id=0c28a40b"
import script from "./Tariff.vue?vue&type=script&lang=js"
export * from "./Tariff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports